/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEquipmentBrowserViewRequest = {
  /**
   * The id of the equipment browser view. If not specified, the default view will be returned.
   */
  viewId?: string | undefined;
  agentId: string;
};

/** @internal */
export const GetEquipmentBrowserViewRequest$inboundSchema: z.ZodType<
  GetEquipmentBrowserViewRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  view_id: types.optional(types.string()),
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "view_id": "viewId",
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetEquipmentBrowserViewRequest$Outbound = {
  view_id?: string | undefined;
  agent_id: string;
};

/** @internal */
export const GetEquipmentBrowserViewRequest$outboundSchema: z.ZodType<
  GetEquipmentBrowserViewRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentBrowserViewRequest
> = z.object({
  viewId: z.string().optional(),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    viewId: "view_id",
    agentId: "agent_id",
  });
});

export function getEquipmentBrowserViewRequestToJSON(
  getEquipmentBrowserViewRequest: GetEquipmentBrowserViewRequest,
): string {
  return JSON.stringify(
    GetEquipmentBrowserViewRequest$outboundSchema.parse(
      getEquipmentBrowserViewRequest,
    ),
  );
}
export function getEquipmentBrowserViewRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEquipmentBrowserViewRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEquipmentBrowserViewRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEquipmentBrowserViewRequest' from JSON`,
  );
}
